module.exports = __webpack_public_path__ + "static/media/background.f01b1809.png";